import { render, staticRenderFns } from "./klaus-peter-keller.vue?vue&type=template&id=130b8078&scoped=true"
import script from "./klaus-peter-keller.vue?vue&type=script&lang=js"
export * from "./klaus-peter-keller.vue?vue&type=script&lang=js"
import style0 from "./klaus-peter-keller.vue?vue&type=style&index=0&id=130b8078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b8078",
  null
  
)

export default component.exports